<template>
  <div class="page-container">
    <NavBar :data="navbarData" />
    <div class="page-content-wrapper">
      <el-container>
        <el-aside width="150px">
          <div class="left-aside">
            <ul class="feed-menu">
              <li @click="refreshFeedList" class="active">热门</li>
              <li @click="loginTip">推荐</li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <div class="feed-container" v-loading="hotShade">
            <FeedItem
              v-for="feed in hotList"
              :key="feed.modelId"
              :feed="feed"
              :authors="authorList"
              :headScene="headScene"
            />
          </div>
          <PhotoPreviewer />
        </el-main>
        <el-aside width="340px">
          <div class="right-aside">
            <LoginForm />
          </div>
        </el-aside>
      </el-container>
    </div>
    <Footer />
    <ScrollTop />
  </div>
</template>
<script>
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import ScrollTop from "../components/scrollTop";
import PhotoPreviewer from "../components/PhotoPreviewer";
import LoginForm from "../components/LoginForm";
import FeedItem from "../components/community/feed-item";
import { apiMap } from "../utils/apiMap";
import { reviewTime } from "../utils/date";
export default {
  name: "public",
  data() {
    return {
      navbarData: [
        { title: "首页", path: "/" },
        { title: "社区", path: "/square" },
        { title: "关于", path: "/about" },
        { title: "登录", path: "/login" },
      ],
      hotPage: 1,
      hotList: [],
      hotShade: true,
      onFetching: false,
      authorList: [],
      topList: [],
      headScene: "public",
    };
  },
  components: {
    NavBar,
    Footer,
    ScrollTop,
    PhotoPreviewer,
    LoginForm,
    FeedItem,
  },
  beforeMount() {
    this.getHotFeed();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getHotFeed() {
      let $this = this;
      let params = `start=${this.hotPage}&count=10`;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["hotFeed"]["method"],
          url: apiMap["hotFeed"]["url"],
          data: params,
          timeout: 4000,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            // response.data.result.data.forEach(element => {
            //     $this.hotList.push(element);
            // });
            $this.hotShade = false;
            let sortedData = response.data.result.data;
            // let sortedData = sortHotFeed(response.data.result.data);
            if (sortedData.length == 0) {
              $this.$message({
                message: "暂无数据",
              });
              $this.onFetching = true;
              return false;
            }
            for (let index = 0; index < sortedData.length; index++) {
              const element = sortedData[index];
              //过滤音频 和 视频
              //过滤音频 和 视频 和未通过审核的动态
              if (element.article == 3 || element.article == 4) {
                continue;
              }
              var topStatus = "noRecord";
              if (element.top == 1) {
                if ($this.topList.includes(element.modelId)) {
                  topStatus = "hasRecord";
                } else {
                  $this.topList.push(element.modelId);
                }
              }
              var unTopArr = sortedData.filter((item) => item.top == 0);
              if (unTopArr.length == 0) {
                $this.finishTip();
              }
              var diffTime =
                response.data.result.requestTime - element.created_at;
              var reviewStatus = diffTime > reviewTime ? "pass" : "fail";
              if (reviewStatus == "pass" && topStatus == "noRecord") {
                $this.hotList.push(element);
              }
            }
          }
          if (response.data.result.data.length == 0) {
            $this.finishTip();
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.message.includes("timeout")) {
            $this.$message({
              message: "获取社区动态超时",
            });
          } else {
            $this.$message({
              message: "获取社区动态出错",
              type: "warning",
            });
          }
        });
    },
    loginTip() {
      this.$message({
        message: "请先登录",
      });
    },
    finishTip() {
      this.$message({
        message: "热门动态加载完啦，请浏览其他内容",
      });
      this.onFetching = true;
    },
    refreshFeedList() {
      this.hotPage = 1;
      this.hotList = [];
      this.hotShade = true;
      this.onFetching = true;
      this.getHotFeed();
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (this.onFetching) {
      } else {
        if (windowHeight >= scrollHeight - scrollTop - 5) {
          this.onFetching = true;
          setTimeout(() => {
            this.hotPage += 1;
            this.getHotFeed();
            this.onFetching = false;
          }, 500);
        }
      }
    },
  },
};
</script>
<style scoped>
.page-container .header-wrapper {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
  border-bottom: solid 1px #e6e6e6;
}

.page-content-wrapper {
  width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  padding-top: 82px;
}

.left-aside {
  position: fixed;
  width: 150px;
  text-align: center;
  line-height: 40px;
}

.left-aside .feed-menu {
  background-color: #fff;
}

.feed-menu li {
  font-size: 16px;
  cursor: pointer;
}

.feed-menu .active {
  color: #409eff;
}

.feed-container {
  width: 670px;
  min-height: 216px;
  margin: 0 auto;
}

.right-aside {
  position: fixed;
  width: 340px;
  background-color: #fff;
}
</style>
